
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import Tooltip from 'bootstrap/js/dist/tooltip';

@Component({
    selector: 'app-product-delete-icon',
    imports: [],
    templateUrl: './product-delete-icon.component.html',
    styleUrls: ['./product-delete-icon.component.scss']
})
export class ProductDeleteIconComponent implements AfterViewInit, OnDestroy {
  @Input() public toolTipHtmlContent: string | undefined;
  @Input() public sizeInPx: number;

  @Output() public deleteSubmit: EventEmitter<void> = new EventEmitter();

  @ViewChild('deleteIconTooltipContainer') addToCartIconTooltipContainerRef: ElementRef<HTMLSpanElement> | undefined;
  private addToCartIconTooltip: Tooltip | undefined;

  public constructor() {
    this.sizeInPx = 32;
  }

  ngAfterViewInit(): void {
    if (this.addToCartIconTooltipContainerRef) {
      this.addToCartIconTooltip = new Tooltip(this.addToCartIconTooltipContainerRef.nativeElement);
    }
  }

  public ngOnDestroy(): void {
    this.addToCartIconTooltip?.dispose();
  }

  public deleteClicked() {
    this.deleteSubmit.emit();
  }
}
